import React, { Component } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import ScrollBars from "react-custom-scrollbars"
import TreeContainer from "../../../layout/checkbox-tree/TreeContainer"
import LocationTreeShape from "../../../../state/shapes/LocationTreeShape"

class CustomReportLocationSelection extends Component {
  static propTypes = {
    treeData: PropTypes.arrayOf(PropTypes.shape(LocationTreeShape)).isRequired,
    selectedValues: PropTypes.arrayOf(PropTypes.number).isRequired,
    theme: PropTypes.shape({
      primaryColor: PropTypes.string.isRequired,
      primaryColorHover: PropTypes.string.isRequired,
      navBackgroundColor: PropTypes.string.isRequired,
    }).isRequired,
    locationsChanged: PropTypes.func.isRequired,
  }
  state = {
    checkedKeys: [],
    flatData: [],
    defaultCheckedKeys: [],
    mountSetStateComplete: false,
  }

  componentDidMount = () => {
    // The selected ids come in as an array of integers
    // but the tree checkbox control requires an array of strings
    // so map the prop value into the state.checked value
    // Internal state is required as we only want to change the value
    // in the store upon clicking "Submit"
    let selectedIds = []
    if (this.props.selectedValues && this.props.selectedValues.length > 0) {
      selectedIds = this.props.selectedValues.map(x => x.toString())
      this.setState({ defaultCheckedKeys: selectedIds, mountSetStateComplete: true })
    } else {
      this.setState({ mountSetStateComplete: true })
    }

    // Flatten the tree data to make it easy to find labels to display
    // for selected value later
    const flatten = (items, depth, parentName, parentValue) => {
      const flat = []
      Array.from(items).forEach((item) => {
        const flatItem = {
          value: Number(item.value),
          label: item.label,
          depth,
          parentValue,
          locationPathName: parentName && parentName.length > 0 ? parentName : "",
          hasChildren: item.children && item.children.length > 0,
        }
        flat.push(flatItem)
        if (flatItem.hasChildren) {
          flat.push(...flatten(
            item.children,
            depth + 1,
            flatItem.locationPathName && flatItem.locationPathName.length > 0
              ? `${flatItem.locationPathName} > ${flatItem.label}`
              : flatItem.label,
            flatItem.value
          ))
        }
      })

      return flat
    }

    const flatData = flatten(this.props.treeData, 0, "", 0)

    this.setState({ flatData })
  }

  onCheckChange = (keys) => {
    this.setState({ checkedKeys: keys }, () => {
      this.props.locationsChanged(this.state.checkedKeys)
    })
  }

  render() {
    const { treeData, theme } = this.props
    return (
      <div>
        <ScrollBars autoHeight autoHeightMin={400}>
          {this.state.mountSetStateComplete ? (
            <TreeContainer
              treeData={treeData}
              flatData={this.state.flatData}
              theme={theme}
              defaultCheckedKeys={this.state.defaultCheckedKeys}
              onCheckChange={this.onCheckChange}
            />
          ) : null}
        </ScrollBars>
      </div>
    )
  }
}

export default translate()(CustomReportLocationSelection)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/LocationsEmployeesSelection/CustomReportLocationSelection.jsx